// src/router/cargos.js

// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['peopleCulture']

const departamentosBreadCrumb = [
  {
    label: 'Home',
    to: 'Home'
  },
  {
    label: 'Departamentos',
    to: 'Departamentos'
  }
]

export default [
  {
    path: '/departamentos',
    name: 'Departamentos',
    component: () => import('@/views/Departamentos/DepartamentoListPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Departamentos',
      breadcrumb: departamentosBreadCrumb
    },
  },
  {
    path: '/departamentos/novo',
    name: 'DepartamentoNovo',
    component: () => import('@/views/Departamentos/NovoDepartamentoPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Novo Departamento',
      breadcrumb: [
        ...departamentosBreadCrumb,
        {
          label: 'Novo Departamento',
          to: 'DepartamentoNovo'
        }
      ]
    }
  },
  {
    path: '/departamentos/:id/edit',
    name: 'Departamentosdit',
    component: () => import('@/views/Departamentos/NovoDepartamentoPage.vue'),
    meta: {
      roles: ROLES,
      title: 'Detalhes do Departamento',
      breadcrumb: [
        ...departamentosBreadCrumb,
        {
          label: 'Novo Departamento',
          to: 'DepartamentoNovo'
        }
      ]
    }
  }

];
